<template>
  <div class="landscape--warning">
    <asset-v3
      dir="context"
      name="onboarding-landscape.svg"
    />
    <p class="gray-900 body-semi-bold text-center">
      Para prosseguir, coloque seu celular na posição vertical
    </p>
  </div>
</template>

<script>
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  name: 'v2-landscape-warning',
  components: {
    AssetV3,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .landscape--warning {
    min-height: 100vh;
    height: 100vh;
    width: 100vw;
    min-width: 100vw;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 24px;
  }

</style>
